import { IonButton, IonLabel } from '@ionic/react'
import React, { BaseSyntheticEvent } from 'react'
import { useDispatch } from 'react-redux'

export interface IButton {
  label?: string
  action?: string
  size?: 'small' | 'default' | 'large' | undefined
  color?: string
  fill?: 'clear' | 'default' | 'outline' | 'solid' | undefined
  expand?: 'block' | 'full' | undefined
}

const ButtonComponent: React.FC<IButton> = (props: IButton) => {
  const { label, action, color, size, fill, expand } = props
  const dispatch = useDispatch()

  const clickAction = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    dispatch({ type: action })
  }

  return (
    <IonButton
      onClick={clickAction}
      color={color ? color : 'primary'}
      size={size ? size : 'default'}
      fill={fill ? fill : 'solid'}
      expand={expand ? expand : 'block'}>
      <IonLabel>{label}</IonLabel>
    </IonButton>
  )
}

export default ButtonComponent
